import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const Backdrop = styled(View)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.55);
  z-index: 9999;
  ${props => (!props.open ? 'display: none;' : '')}

  &.fade-enter {
    opacity: 0;
  }
  &.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
  }
  &.fade-exit {
    opacity: 1;
  }
  &.fade-exit-active {
    opacity: 0;
    transition: opacity 500ms;
  }
`

export default Backdrop
